import { motion } from "framer-motion";

export const LOGO = `${process.env.PUBLIC_URL}/vira-logo.webp`;
export const EASE = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, className }) {
  return (
    <motion.div className={className} initial={{ opacity: 0, y: 46 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-70px" }} transition={{ duration: 0.9, delay, ease: EASE }}>
      {children}
    </motion.div>
  );
}
